import { api } from "./api";

export const portalApi = {
  me: () => api.get("/portal/me").then(r => r.data),
  orgs: () => api.get("/portal/organizations").then(r => r.data),
  resetDemo: (organization_id) => api.post("/portal/demo/reset", { organization_id }).then(r => r.data),

  analyze: (payload) => api.post("/portal/ai-analyze", payload).then(r => r.data),

  generateReport: (payload) => api.post("/portal/reports/generate", payload).then(r => r.data),
  listReports: () => api.get("/portal/reports").then(r => r.data),
  downloadReport: (id, format = "json") =>
    api.get(`/portal/reports/${id}/download`, { params: { format },
      responseType: format === "csv" || format === "md" ? "text" : "json" }).then(r => r.data),

  uploadMeta: (payload) => api.post("/portal/uploads", payload).then(r => r.data),
  listUploads: () => api.get("/portal/uploads").then(r => r.data),

  listUsers: () => api.get("/portal/users").then(r => r.data),
  createUser: (payload) => api.post("/portal/users", payload).then(r => r.data),
  deleteUser: (id) => api.delete(`/portal/users/${id}`).then(r => r.data),

  certMe: () => api.get("/portal/certification/me").then(r => r.data),
  certEnroll: (track) => api.post("/portal/certification/enroll", { track }).then(r => r.data),
  certCertificate: () => api.get("/portal/certification/certificate",
    { responseType: "text" }).then(r => r.data),

  // Curriculum (learner)
  curriculumSections: () => api.get("/portal/curriculum/sections").then(r => r.data),
  curriculumAttempt: (payload) => api.post("/portal/curriculum/attempt", payload).then(r => r.data),
  curriculumMyAttempts: () => api.get("/portal/curriculum/attempts").then(r => r.data),
  curriculumExport: () => api.get("/portal/curriculum/export",
    { responseType: "text" }).then(r => r.data),

  // Tickets (user)
  ticketsCreate: (payload) => api.post("/portal/tickets", payload).then(r => r.data),
  ticketsMine: () => api.get("/portal/tickets/mine").then(r => r.data),
};

export const adminApi = {
  // CMS
  cmsList: () => api.get("/portal/admin/content").then(r => r.data),
  cmsGet: (page, slot) => api.get(`/portal/admin/content/${page}/${slot}`).then(r => r.data),
  cmsPut: (page, slot, value) => api.put(`/portal/admin/content/${page}/${slot}`, { value }).then(r => r.data),

  // CRM
  crmList: (q, status) => api.get("/portal/admin/crm", { params: { q, status } }).then(r => r.data),
  crmCreate: (payload) => api.post("/portal/admin/crm", payload).then(r => r.data),
  crmUpdate: (id, payload) => api.put(`/portal/admin/crm/${id}`, payload).then(r => r.data),
  crmDelete: (id) => api.delete(`/portal/admin/crm/${id}`).then(r => r.data),

  // Media
  mediaList: (folder) => api.get("/portal/admin/media", { params: { folder } }).then(r => r.data),
  mediaCreate: (payload) => api.post("/portal/admin/media", payload).then(r => r.data),
  mediaDelete: (id) => api.delete(`/portal/admin/media/${id}`).then(r => r.data),

  // SEO
  seoList: () => api.get("/portal/admin/seo").then(r => r.data),
  seoPut: (page, payload) => api.put(`/portal/admin/seo/${page}`, payload).then(r => r.data),

  // Email templates
  emailList: () => api.get("/portal/admin/email-templates").then(r => r.data),
  emailPut: (key, payload) => api.put(`/portal/admin/email-templates/${key}`, payload).then(r => r.data),

  // Settings
  settingsGet: () => api.get("/portal/admin/settings").then(r => r.data),
  settingsPut: (payload) => api.put("/portal/admin/settings", payload).then(r => r.data),

  // Dev Builds
  buildsList: () => api.get("/portal/admin/builds").then(r => r.data),
  buildsCreate: (payload) => api.post("/portal/admin/builds", payload).then(r => r.data),
  buildsDecision: (id, payload) => api.post(`/portal/admin/builds/${id}/decision`, payload).then(r => r.data),
  buildsDelete: (id) => api.delete(`/portal/admin/builds/${id}`).then(r => r.data),

  // Audit logs
  auditLogs: (params = {}) => api.get("/portal/admin/audit-logs", { params }).then(r => r.data),

  // Tickets (admin)
  ticketsList: (status, category) => api.get("/portal/admin/tickets", { params: { status, category } }).then(r => r.data),
  ticketsUpdate: (id, payload) => api.put(`/portal/admin/tickets/${id}`, payload).then(r => r.data),
};

export const authExtras = {
  passwordResetRequest: (email) =>
    api.post("/auth/password-reset-request", { email }).then(r => r.data),
  passwordReset: (token, new_password) =>
    api.post("/auth/password-reset", { token, new_password }).then(r => r.data),
};
